export const CALL_TYPES = [
  {
    id: "discovery",
    src: "/images/coaching/discovery_call.svg",
    title: "Discovery Call",
    description: "Help reps uncover customer needs, build rapport, and set the stage for a deal well done",
    enabled: true,
  },
  {
    id: "cold_call",
    src: "/images/coaching/cold_call.svg",
    title: "Cold Call",
    description: "Train reps to confidently open conversations, handle objections, and book meetings—cold call style.",
    enabled: true,
  },
  {
    id: "follow_up",
    src: "/images/coaching/followup.svg",
    title: "Follow-On call",
    description: "Prepare reps to dive deeper, address concerns, and drive momentum- next step unlocked.",
    enabled: false,
  },
];

export const DURATION_CHOICES = [{
  label: "5 mins",
  value: 5,
},{
  label: "10 mins",
  value: 10,
}, {
  label: "15 mins",
  value: 15,
}, {
  label: "20 mins",
  value: 20,
}, {
  label: "25 mins",
  value: 25,
}, {
  label: "30 mins",
  value: 30,
}];

export const DIFFICULTY_CHOICES = [{
  label: "Basic",
  value: "beginner",
}, {
  label: "Intermediate",
  value: "intermediate",
}, {
  label: "Advanced",
  value: "advanced",
}, {
  label: "Complex",
  value: "complex",
}];